import {useLayoutEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';
import Navigation from '../../components/Navigation/Navigation';
import PersonalBlock from '../../components/PersonalBlock/PersonalBlock';
import HowItWorks from '../../components/HowItWorks/HowItWorks';
import WhyTrova from '../../components/WhyTrova/WhyTrova';
import Faq from '../../components/Faq/Faq';
import FooterNav from '../../components/FooterNav/FooterNav';
import * as Styles from './AboutStyles';
import {Col, Container, Row} from 'react-bootstrap';
import Meta from '../../components/Meta/Meta';

const About = () => {
	const myRef = useRef<HTMLDivElement>(null);
	const pageRef = useRef<HTMLDivElement>(null);
	const location = useLocation();

	useLayoutEffect(():void =>{
		if (!location.hash || !pageRef || !pageRef.current) {
			return;
		}
		const el = pageRef.current.querySelector(location.hash);
		if (el) {
			el.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			})
		}
	},[location.hash]);

	return (
		<Styles.Container className="AboutWrapper" ref={pageRef}>
			<Meta page="about" />
			<Navigation logoText />
			<Container fluid="xl">
				<Row>
					<Col xs={12}>
						<PersonalBlock />
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<div ref={myRef} id="how-it-works">
							<HowItWorks />
						</div>
					</Col>
				</Row>
				<Row>
					<WhyTrova />
				</Row>
				<Row className="justify-content-center" id="faq">
					<Col>
						<Faq />
					</Col>
				</Row>
			</Container>
			<FooterNav />
		</Styles.Container>
	);
}

export default About;